import { Link } from "react-router-dom";
import { redirectToSso } from "../../utils/authentication";
import  logoImg  from "../../assets/images/logo.svg";
import { LoginButton, LogoutContainer, LogoutText, LogoutTextHeader, Logo, MainHeaderContainer, Container } from "./styles";

const Logout = () => {

	return (
		<>
			<MainHeaderContainer>
				<Container id="header-container">
					<Link to="/">
						<Logo src={logoImg} alt="kochr" />
					</Link>
				</Container>
			</MainHeaderContainer>
			<LogoutContainer>
				<LogoutTextHeader>
					Güvenli Şekilde çıkış yaptın
				</LogoutTextHeader>
				<LogoutText>Dilersen tekrar giriş yapabilirsin</LogoutText>
				<LoginButton onClick={redirectToSso}>Giriş Yap</LoginButton>
			</LogoutContainer>
		</>
	);
};

export default Logout;
